module.exports = __webpack_public_path__ + "static/media/LegoShadowTheatreINTA0061_design_clean_v001.437befd2.png";